import { useState } from 'react';
import { SIDEBAR_STORAGE_KEY } from '../constants/layout';

export function useSidebarState() {
  const [sidebarOpen, setSidebarOpenState] = useState(
    () => localStorage.getItem(SIDEBAR_STORAGE_KEY) !== 'false'
  );
  const [mobileOpen, setMobileOpen] = useState(false);

  const setSidebarOpen = (updater: (prev: boolean) => boolean) => {
    setSidebarOpenState((prev) => {
      const next = updater(prev);
      localStorage.setItem(SIDEBAR_STORAGE_KEY, String(next));
      return next;
    });
  };

  return { sidebarOpen, setSidebarOpen, mobileOpen, setMobileOpen };
}
